import query from '@/components/query/query-constructor';

const tableQueryDefault = {
  orderDir: 'desc',
  orderBy: 'reports-visits',
  from: '2019-04-01 00:00:00',
  to: '2019-04-01 23:59:59',
  date: 'today',
  limit: 50,
  status: 'active',
  currency: 'USD',
  offset: 0,
  columns: [
    'campaigns-name',
    'reports-visits',
    'reports-visitsuniq',
    'reports-clicks',
    'reports-clicksuniq',
    'reports-conversionconfirm',
    'reports-revenue',
    'reports-cost',
    'reports-profit',
    'reports-cpv',
    'reports-cpc',
    'reports-ctr',
    'reports-1xctr',
    'reports-uctr',
    'reports-cr',
    'reports-1xcr',
    'reports-cv',
    'reports-1xcv',
    'reports-roi',
    'reports-epv',
    'reports-epc',
    'reports-ap',
  ],
  groupBy: 'campaigns',
  formatResponse: 1,
  timezone: 'UTC',
};

const dashboardQueryDefault = {
  date: 'today',
  status: 'active',
  currency: 'AUD',
  orderBy: 'reports-profit',
  sortBy: 'reports-profit',
  orderDir: 'desc',
  from: '2019-04-01 00:00:00',
  to: '2019-04-01 23:59:59',
  direction: 'desc',
  columns: ['reports-profit'],
  groupBy: 'campaigns',
  timezone: 'UTC',
  formatResponse: 1,
  limit: 5,
  offset: 0,
};

export const getDashboardLink = (profile: any): string => {
  const date = new Date().toISOString().replace(/T(.*)$/gi, '');
  const currency = profile.currencyId || 'USD';
  const base =
    profile.defaultHomepage === 'campaigns' ? { ...tableQueryDefault } : { ...dashboardQueryDefault };
  const data = {
    ...base,
    from: date + ' 00:00:00',
    to: date + ' 23:59:59',
    currency,
    timezone: profile.defaultTimezone,
  };
  if (profile.defaultHomepage !== 'campaigns') {
    data.orderDir = profile.dashboardDefaultOrderDir;
    data.orderBy = profile.dashboardDefaultGroup;
  }
  return profile.defaultHomepage === 'campaigns'
    ? `/app/report/campaigns/${query.encode(data)}`
    : `/app/dashboard/${query.encode(data)}`;
};
